import { isAxiosError } from 'axios';

// Older backends don't have this route. A 404 should stop polling immediately.
export function isSuperDispatchLaneContextHardFailure(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 404;
}
